import { FloppyDiskIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Group = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <FloppyDiskIcon {...rest} size={Sizes[size]} color={fill} />;
};

Group.displayName = 'Group';
